'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _l10n = require('../../../common/l10n');

var _l10n2 = _interopRequireDefault(_l10n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template(model) {
    var content = _react2.default.createElement('span', null),
        classList = this.compileStyle(_index2.default);

    if (model) {
        var balance = model.get('balance'),
            number = model.get('number'),
            name = model.get('name'),
            title = name + ' ' + (number ? number.toString('short') : ''),
            icon = null;

        if (typeof model.isVisa === 'function' && model.isVisa()) {
            icon = _react2.default.createElement(
                'span',
                { className: classList.iconWrapper },
                _react2.default.createElement('span', { className: classList.visa })
            );
        } else if (typeof model.isMasterCard === 'function' && model.isMasterCard()) {
            icon = _react2.default.createElement(
                'span',
                { className: classList.iconWrapper },
                _react2.default.createElement('span', { className: classList.mc })
            );
        }

        // что бы не добавлять key всем спанам сделаем дублирование кода
        if (balance) {
            content = _react2.default.createElement(
                'span',
                {
                    value: model.id,
                    className: classList.root,
                    title: title,
                    name: title
                },
                _react2.default.createElement(
                    'span',
                    { className: icon ? classList.textWrapper : '' },
                    _react2.default.createElement(
                        'span',
                        { className: classList.balance },
                        balance.toString(null, null, true)
                    ),
                    _react2.default.createElement(
                        'small',
                        { className: classList.currency },
                        _l10n2.default.translate(model.get('currency').toString()) || ''
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: classList.number },
                        number ? number.toString('short') : ''
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: classList.name },
                        name
                    )
                ),
                icon
            );
        } else {
            content = _react2.default.createElement(
                'span',
                {
                    value: model.id,
                    className: classList.root,
                    title: title,
                    name: title
                },
                _react2.default.createElement(
                    'span',
                    { className: icon ? classList.textWrapper : '' },
                    _react2.default.createElement(
                        'span',
                        { className: classList.number },
                        number ? number.toString('short') : ''
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: classList.name },
                        name
                    )
                ),
                icon
            );
        }
    }

    return content;
}